import React from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";

// import Register from "../pages/Auth/Register";
// import ForgotPassword from "../pages/Auth/ForgotPassword";
import Dashboard from "pages/Dashboard";
import Quiz from "pages/Quiz";
import Teams from "pages/Teams";
import Scoring from "pages/Scoring";
import ScoringRound from "pages/Scoring/Round";
import ScoringTeam from "pages/Scoring/Team";
import Help from "pages/Help";
import Login from "pages/Auth/Login";
import Questions from "pages/Questions";
import Tools from "pages/Tools";

import Loading from "components/Loading";

interface Props {
}

const InternalRoutes: React.FC<Props> = () => {
  return (
    <>
      <Loading />
      <Route exact path="/">
        <Dashboard/>
      </Route>
      <Route exact path="/dashboard">
        <Dashboard/>
      </Route>
      <Route exact path="/quiz">
        <Quiz/>
      </Route>
      <Route exact path="/questions">
        <Questions/>
      </Route>
      <Route exact path="/teams">
        <Teams/>
      </Route>
      <Route exact path="/scoring">
        <Scoring/>
      </Route>
      <Route exact path="/scoring/:roundId">
        <ScoringRound/>
      </Route>
      <Route exact path="/scoring/:roundId/team/:teamId">
        <ScoringTeam/>
      </Route>
      <Route exact path="/help">
        <Help/>
      </Route>
      <Route exact path="/tools">
        <Tools/>
      </Route>
      <Route exact path="/login">
        <Login />
      </Route>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  // loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps, {})(InternalRoutes);
